import React from 'react';
import Component from '@vfuk/core-color-select-with-label';
const ColorSelectWithLabel = props => {
    return React.createElement(Component, Object.assign({}, props));
};
export default ColorSelectWithLabel;
